<template>
  <div class="rb-display-controls">
    <span>{{ label }}</span>
    <button
      :class="[
        'rb-btn-display rb-btn-table',
        { 'rb-active': displayMode === 'table' },
      ]"
      id="btn-display-list"
      aria-label="Display as List"
      @click.prevent="notifyDisplayMode($event, 'table')"
    >
      <icon-list />
    </button>
    <button
      :class="[
        'rb-btn-display rb-btn-grid',
        { 'rb-active': displayMode === 'grid' },
      ]"
      id="btn-display-grid"
      aria-label="Display as Grid"
      @click.prevent="notifyDisplayMode($event, 'grid')"
    >
      <icon-grid />
    </button>
  </div>
</template>
<script>
/**
 * Buttons to change display mode for diamonds (grid or table)
 *
 * @props
 * label: String
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-set-display-mode
 *
 * @listens
 * rb-set-display-mode
 *
 */
import IconList from "@/components/icons/IconList";
import IconGrid from "@/components/icons/IconGrid";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
export default {
  components: { IconList, IconGrid },
  mixins: [CommMixin, TrackMixin],
  props: {
    label: {
      type: String,
      default: "Change View:",
    },
  },
  data: function () {
    return {
      displayMode: "table",
    };
  },
  mounted: function () {
    this.subscribe("rb-set-display-mode", this.onSetDisplayMode);
  },
  methods: {
    onSetDisplayMode: function (data) {
      this.displayMode = data.mode;
    },
    notifyDisplayMode: function (event, mode) {
      this.broadcast("rb-set-display-mode", { mode });
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
  },
};
</script>
